import { useEffect, useState } from 'react';
import {
    useLazyNotesQuery,
    useNewNoteMutation,
    useUpdateNoteMutation,
    AimNote
} from '@repo/services';
import {convertStringOrUndefinedToNumber} from "../stringUtils";
import {createFormDataObject} from "../formUtils";
import useAgMutation from "./useAgMutation";
import {notifications} from "@mantine/notifications";

/**
 * A React hook that creates and manages Aim notes for a given entity. Returns createNote and createNotesBulk functions for creating notes programmatically.
 *
 * @param id - The id of the target entity (aimId). Notes will be associated with this id.
 */
export const useNotes = ({ id }: { id: string | undefined }) => {
    const {
        trigger: triggerCreateNewNote,
        isLoading: createNewIsLoading,
        data: newNoteData
    } = useAgMutation(useNewNoteMutation, () => {});
    const createNote = ({ title, message, newNoteId = '0' }: { title: string; message: string, newNoteId?: string }) => {
        if (newNoteId) id = newNoteId;
        if (id && id !== '0') {
            const payload = createFormDataObject({
                title,
                message
            });
            triggerCreateNewNote({
                aimId: convertStringOrUndefinedToNumber(id, 0),
                noteId: 0,
                data: payload
            });
        }
    };

    const createNotesBulk = ({ notes, newNoteId = '0' }: { notes: AimNote[], newNoteId?: string }) => {
        if (notes && notes?.length > 0) {
            notes.forEach((note) => createNote({ title: note.title, message: note.message, newNoteId: newNoteId }));
        }
    }

    return { createNote, createNotesBulk };
};
